module.exports = __webpack_public_path__ + "OpenSans-ExtraBold.561e4b63e9119235465e.eot";


//////////////////
// WEBPACK FOOTER
// D:/Work/Biddle/biddle-training-module/biddle-training-admin/node_modules/npm-font-open-sans/fonts/ExtraBold/OpenSans-ExtraBold.eot
// module id = ../../../../npm-font-open-sans/fonts/ExtraBold/OpenSans-ExtraBold.eot
// module chunks = styles